import { render } from "./xpay.vue?vue&type=template&id=7a6b1a15"
import script from "./xpay.js?vue&type=script&lang=js&external"
export * from "./xpay.js?vue&type=script&lang=js&external"

import "./xpay.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__